export const apiAdminInitializer = () => {
  // add routes
  $core.$router.addRoutes([
    {
      path: '/api/list',
      component: $frameworkUtils.defineAsyncComponent(() => import('./ApiList.vue')),
    },
  ])
}
